/**
 * Try to geocode a location using OpenWeatherMap API
 *
 * Returns a list with objects of the form:
 *
 * {
 *   "name": "City Name",
 *   "local_names": {
 *     "en": "City Name",
 *     ...
 *   },
 *   "lat": 12.34,
 *   "lon": 56.78,
 *   "country": "US",
 *   "state": "State Name"
 * }
 *
 * @param apiKey open weather map api key
 * @param query location query string
 * @returns {Promise<any>}
 */
export async function tryGeocode(apiKey, query) {
  const res = await fetch(
    'https://api.openweathermap.org/geo/1.0/direct?' + new URLSearchParams({
      q: `${query},US`,
      appid: apiKey,
    }).toString());

  return await res.json();
}

/**
 * Fetch OpenWeatherMap city ID for a given full city name
 *
 * @param cityIdApiKey open weather map city id api key
 * @param fullCityName city name in the form of "City, State, Country"
 * @returns {Promise<void>}
 */
export async function fetchCityId(cityIdApiKey, fullCityName) {
  const res = await fetch(
    'https://openweathermap.org/data/2.5/find?' + new URLSearchParams({
      q: fullCityName,
      type: 'like',
      sort: 'population',
      cnt: 30,
      appid: cityIdApiKey,
    }).toString()
  );
  const data = await res.json();
  if (data.cod === "200" && data.count > 0) {
    return data.list[0].id.toString();
  } else {
    throw new Error("Bad response from fetching city ID " + JSON.stringify(data));
  }
}

const OpenWeatherMap = {
  tryGeocode,
  fetchCityId,
}
export default OpenWeatherMap;